module.exports = __webpack_public_path__ + "static/media/aws.bf07b30e.svg";